import { IconDefinition, SizeProp } from '@fortawesome/fontawesome-svg-core';
import {
	faApple,
	faAppStoreIos,
	faCcStripe,
	faFacebook,
	faFigma,
	faGithub,
	faGoogle,
	faGoogleDrive,
	faGooglePlay,
	faInstagram,
	faJira,
	faKeycdn,
	faPaypal,
	faSlack,
	faSnapchat,
	faSquareFacebook,
	faXTwitter,
	faYoutube
} from '@fortawesome/free-brands-svg-icons';
import {
	faAddressBook,
	faAddressCard,
	faArchive,
	faArrowDownArrowUp,
	faArrowDownLeftAndArrowUpRightToCenter,
	faArrowRightArrowLeft,
	faArrowRightFromBracket,
	faArrowUpArrowDown,
	faArrowUpFromBracket,
	faBadgeCheck,
	faBadgeDollar,
	faBadgePercent,
	faBadgeSheriff,
	faBallotCheck,
	faBars,
	faBell,
	faBellExclamation,
	faBillboard,
	faBoxArchive,
	faBoxDollar,
	faBuildingColumns,
	faBullseyeArrow,
	faCalculator,
	faCalendar,
	faCalendarCheck,
	faCalendarCirclePlus,
	faCalendarDays,
	faCalendarLinesPen,
	faCancel,
	faChartColumn,
	faChartLine,
	faChartMixed,
	faChartNetwork,
	faChartTreeMap,
	faChartUser,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronsLeft,
	faChevronsRight,
	faChevronUp,
	faCircleArrowUpRight,
	faCircleCheck,
	faCircleDashed,
	faCircleDollar,
	faCircleExclamation,
	faCircleInfo,
	faCirclePlus,
	faCircleX,
	faClock,
	faCloudArrowDown,
	faCode,
	faCodePullRequest,
	faCoins,
	faComments,
	faCopy,
	faCreditCard,
	faCreditCardBlank,
	faCreditCardFront,
	faDesktop,
	faDiagramProject,
	faDiagramSankey,
	faDistributeSpacingVertical,
	faDollarSign,
	faDotCircle,
	faEllipsis,
	faEllipsisVertical,
	faExclamationCircle,
	faEye,
	faEyeSlash,
	faFileCheck,
	faFileExport,
	faFileImage,
	faFileLines,
	faFileSpreadsheet,
	faFlagPennant,
	faFolderGrid,
	faGalleryThumbnails,
	faGameBoardSimple,
	faGauge,
	faGaugeHigh,
	faGear,
	faGrid2,
	faGridDividers,
	faGridRound2Plus,
	faHandHoldingCircleDollar,
	faHandHoldingDollar,
	faHandshakeAngle,
	faHouseFlag,
	faImage,
	faImagePolaroidUser,
	faListCheck,
	faLocationDot,
	faLock,
	faMagnifyingGlass,
	faMemoCircleCheck,
	faMessageExclamation,
	faMessageLines,
	faMobile,
	faMoneyBills,
	faMoneyCheckAlt,
	faMoneyCheckDollarPen,
	faMoneySimpleFromBracket,
	faNetworkWired,
	faNewspaper,
	faObjectsColumn,
	faPalette,
	faPaperPlane,
	faPause,
	faPenField,
	faPeopleArrows,
	faPercentage,
	faPersonThroughWindow,
	faPhone,
	faPlus,
	faPrint,
	faQrcode,
	faRankingStar,
	faReceipt,
	faRectangleHistory,
	faRectangleList,
	faScreenUsers,
	faShield,
	faShuffle,
	faSlidersSimple,
	faSlidersV,
	faSpinner,
	faSquarePollHorizontal,
	faSquareStar,
	faSquareUser,
	faStar,
	faStarHalfStroke,
	faStars,
	faStore,
	faTableColumns,
	faTableLayout,
	faTablet,
	faTags,
	faTimeline,
	faTimelineArrow,
	faTimer,
	faToggleOn,
	faTrash,
	faTrashCan,
	faTree,
	faTrophy,
	faTshirt,
	faTv,
	faUser as faUserThin,
	faUserCheck,
	faUserGroup,
	faUserPlus,
	faUsers,
	faUsersRectangle,
	faWavePulse,
	faWebhook,
	faWindow,
	faWindowFlip,
	faXmark
} from '@fortawesome/pro-regular-svg-icons';
import { faCalculatorSimple, faCheck, faClub, faPeopleRoof, faRotate, faTimes, faUser, faUserSecret } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import React from 'react';

import { cn } from '@pickleballinc/ui/lib/utils';

import ArrowLeftOrange from './assets/icons/arrow-left-orange.svg';
import ArrowLeft from './assets/icons/arrow-left.svg';
import BallOrange from './assets/icons/ball-orange.svg';
import Ball from './assets/icons/ball.svg';
import DoublesIcon from './assets/icons/doubles-icon.svg';
import InjuredReserveOrange from './assets/icons/injured-reserve-orange.svg';
import MixedIcon from './assets/icons/mixed-icon.svg';
import PlusOrange from './assets/icons/plus-orange.svg';
import Plus from './assets/icons/plus.svg';
import PPAIcon from './assets/icons/ppa-points-icon.svg';
import SinglesIcon from './assets/icons/singles-icon.svg';
import SwapOrange from './assets/icons/swap-orange.svg';
import Swap from './assets/icons/swap.svg';
import AnalyticsIcon from './assets/images/analytics-icon';
import Logo from './assets/images/logo-purple.svg';
import OrganizationsIcon from './assets/images/organizations-icon';
import TeamLeaguesIcon from './assets/images/team-leagues-icon';
import TournamentsBlackIcon from './assets/images/tournaments-black-icon';
import TournamentsIcon from './assets/images/tournaments-icon';
import UsersIcon from './assets/images/users-icon';

export type FaGlyph =
	| 'billing-addresses'
	| 'managers'
	| 'apple'
	| 'display-order'
	| 'badge-check'
	| 'discount'
	| 'pre-registration'
	| 'notifications'
	| 'sponsors'
	| 'building-columns'
	| 'fee-schedule'
	| 'genius-competitions'
	| 'reports'
	| 'info'
	| 'payments'
	| 'system-approvals'
	| 'download'
	| 'login-history'
	| 'credit-card-front'
	| 'methods'
	| 'credit-card'
	| 'copy'
	| 'coins'
	| 'desktop'
	| 'affiliation-overview'
	| 'affiliates'
	| 'memberships'
	| 'division'
	| 'facebook'
	| 'game-maker'
	| 'description'
	| 'score-sheets'
	| 'matches'
	| 'plan-info'
	| 'product-access'
	| 'services'
	| 'partners'
	| 'hp-marketing'
	| 'instagram'
	| 'profile-images'
	| 'clubs-included'
	| 'change-password'
	| 'search'
	| 'mobile'
	| 'cc-movements'
	| 'free-credits'
	| 'money-bills'
	| 'news'
	| 'associations'
	| 'paper-plane'
	| 'print'
	| 'enter-club-games'
	| 'wp-rankings'
	| 'password-history'
	| 'snapchat'
	| 'teams'
	| 'permissions'
	| 'shirt'
	| 'logs'
	| 'players'
	| 'edit'
	| 'owners'
	| 'wp-ratings'
	| 'table-columns'
	| 'table-layout'
	| 'seasons'
	| 'history'
	| 'trophy'
	| 'timer'
	| 'adjustments'
	| 'lookups'
	| 'users'
	| 'guests'
	| 'tags'
	| 'x-twitter'
	| 'youtube'
	| 'chevrons-left'
	| 'chevrons-right'
	| 'chevron-left'
	| 'chevron-right'
	| 'tournaments'
	| 'homepage-editor'
	| 'dashboard'
	| 'districts'
	| 'messages'
	| 'location'
	| 'player-analytics'
	| 'overall-analytics'
	| 'logo-and-files'
	| 'bookings'
	| 'activities'
	| 'waivers'
	| 'adjust'
	| 'notice'
	| 'additional-fees'
	| 'clubs'
	| 'stats'
	| 'add'
	| 'tours-and-series'
	| 'players2'
	| 'user-info'
	| 'image'
	| 'comments'
	| 'requests'
	| 'commissioner'
	| 'featured'
	| 'delete'
	| 'kiosk'
	| 'membership-history'
	| 'family'
	| 'vertical-menu'
	| 'horizontal-menu'
	| 'tablet'
	| 'hamburger-menu'
	| 'logout'
	| 'chevron-down'
	| 'chevron-up'
	| 'transactions'
	| 'user'
	| 'user-thin'
	| 'trash-can'
	| 'loading'
	| 'check'
	| 'google'
	| 'hand-holding-dollar'
	| 'dollar-box'
	| 'star-half-stroke'
	| 'gallery-thumbnails'
	| 'phone'
	| 'circle-arrow-up-right'
	| 'window'
	| 'close'
	| 'circle-plus'
	| 'remove'
	| 'eye'
	| 'tree'
	| 'skinny'
	| 'affiliation-requests'
	| 'memo-circle-check'
	| 'swap-horizontal'
	| 'swap-vertical'
	| 'circle-x'
	| 'database-sync'
	| 'eye-closed'
	| 'connect'
	| 'tv'
	| 'people-roof'
	| 'tournament-icon'
	| 'impersonate'
	| 'warning'
	| 'archive'
	| 'objects-column'
	| 'calendar'
	| 'palette'
	| 'bullseye-arrow'
	| 'percentage'
	| 'pause'
	| 'trial'
	| 'active'
	| 'canceled'
	| 'failed'
	| 'member-upload'
	| 'export'
	| 'archive'
	| 'calculator'
	| 'people-arrow'
	| 'news-content'
	| 'executive-dashboards-icon'
	| 'dollar-sign'
	| 'stripe-logo'
	| 'paypal-logo'
	| 'api-calls'
	| 'exdash-clubs'
	| 'dev-tools'
	| 'app-store'
	| 'google-play'
	| 'slack'
	| 'figma'
	| 'github'
	| 'jira'
	| 'bunnycdn'
	| 'gworkspaces'
	| 'fbpixel'
	| 'gear'
	| 'affiliation-distributions'
	| 'player-movement'
	| 'api'
	| 'move';

const faGlyphs = new Map<FaGlyph, IconDefinition>([
	['billing-addresses', faAddressBook],
	['managers', faAddressCard],
	['apple', faApple],
	['display-order', faArrowDownArrowUp],
	['badge-check', faBadgeCheck],
	['discount', faBadgePercent],
	['pre-registration', faBallotCheck],
	['notifications', faBell],
	['sponsors', faBillboard],
	['building-columns', faBuildingColumns],
	['fee-schedule', faCalendarLinesPen],
	['genius-competitions', faCalendarDays],
	['player-movement', faPersonThroughWindow],
	['reports', faChartLine],
	['info', faCircleInfo],
	['payments', faCircleDollar],
	['system-approvals', faCircleCheck],
	['download', faCloudArrowDown],
	['login-history', faClock],
	['credit-card-front', faCreditCardFront],
	['methods', faCreditCardBlank],
	['credit-card', faCreditCard],
	['copy', faCopy],
	['coins', faCoins],
	['desktop', faDesktop],
	['affiliation-overview', faDiagramSankey],
	['affiliates', faDiagramProject],
	['memberships', faBadgeDollar],
	['division', faDistributeSpacingVertical],
	['facebook', faFacebook],
	['game-maker', faGameBoardSimple],
	['description', faFileLines],
	['score-sheets', faFileSpreadsheet],
	['matches', faGridDividers],
	['plan-info', faGrid2],
	['product-access', faGridRound2Plus],
	['services', faHandHoldingDollar],
	['partners', faHandshakeAngle],
	['hp-marketing', faHouseFlag],
	['instagram', faInstagram],
	['profile-images', faImagePolaroidUser],
	['clubs-included', faListCheck],
	['change-password', faLock],
	['search', faMagnifyingGlass],
	['mobile', faMobile],
	['cc-movements', faMoneySimpleFromBracket],
	['free-credits', faMoneyCheckDollarPen],
	['money-bills', faMoneyBills],
	['news', faNewspaper],
	['associations', faNetworkWired],
	['paper-plane', faPaperPlane],
	['print', faPrint],
	['enter-club-games', faPenField],
	['wp-rankings', faRankingStar],
	['password-history', faRectangleHistory],
	['snapchat', faSnapchat],
	['teams', faScreenUsers],
	['permissions', faShield],
	['shirt', faTshirt],
	['logs', faSquarePollHorizontal],
	['players', faSquareUser],
	['edit', faSlidersSimple],
	['owners', faStars],
	['wp-ratings', faStar],
	['table-columns', faTableColumns],
	['table-layout', faTableLayout],
	['seasons', faTimelineArrow],
	['history', faTimeline],
	['trophy', faTrophy],
	['timer', faTimer],
	['adjustments', faToggleOn],
	['lookups', faWindowFlip],
	['users', faUsers],
	['user', faUser],
	['user-thin', faUserThin],
	['guests', faUserPlus],
	['tags', faTags],
	['x-twitter', faXTwitter],
	['youtube', faYoutube],
	['chevrons-left', faChevronsLeft],
	['chevrons-right', faChevronsRight],
	['chevron-left', faChevronLeft],
	['chevron-right', faChevronRight],
	['tournaments', faChartColumn],
	['homepage-editor', faChartTreeMap],
	['dashboard', faGauge],
	['districts', faCircleDashed],
	['messages', faMessageLines],
	['location', faLocationDot],
	['player-analytics', faChartUser],
	['overall-analytics', faChartMixed],
	['logo-and-files', faFileImage],
	['bookings', faCalendarCheck],
	['activities', faWavePulse],
	['waivers', faFileCheck],
	['adjust', faSlidersV],
	['notice', faMessageExclamation],
	['additional-fees', faCalendarCirclePlus],
	['clubs', faChartNetwork],
	['stats', faGaugeHigh],
	['add', faPlus],
	['tours-and-series', faFlagPennant],
	['players2', faUserGroup],
	['user-info', faUserCheck],
	['image', faImage],
	['comments', faComments],
	['requests', faCodePullRequest],
	['commissioner', faBadgeSheriff],
	['featured', faSquareStar],
	['delete', faTrash],
	['kiosk', faStore],
	['membership-history', faRectangleList],
	['family', faUsersRectangle],
	['vertical-menu', faEllipsisVertical],
	['horizontal-menu', faEllipsis],
	['tablet', faTablet],
	['hamburger-menu', faBars],
	['logout', faArrowRightFromBracket],
	['chevron-down', faChevronDown],
	['chevron-up', faChevronUp],
	['transactions', faReceipt],
	['trash-can', faTrashCan],
	['loading', faSpinner],
	['check', faCheck],
	['google', faGoogle],
	['remove', faXmark],
	['hand-holding-dollar', faHandHoldingCircleDollar],
	['dollar-box', faBoxDollar],
	['star-half-stroke', faStarHalfStroke],
	['gallery-thumbnails', faGalleryThumbnails],
	['phone', faPhone],
	['circle-arrow-up-right', faCircleArrowUpRight],
	['window', faWindow],
	['close', faTimes],
	['circle-plus', faCirclePlus],
	['eye', faEye],
	['tree', faTree],
	['skinny', faArrowDownLeftAndArrowUpRightToCenter],
	['affiliation-requests', faBellExclamation],
	['memo-circle-check', faMemoCircleCheck],
	['member-upload', faArrowUpFromBracket],
	['circle-x', faCircleX],
	['database-sync', faRotate],
	['eye-closed', faEyeSlash],
	['swap-horizontal', faArrowRightArrowLeft],
	['swap-vertical', faArrowUpArrowDown],
	['affiliation-requests', faBellExclamation],
	['tv', faTv],
	['people-roof', faPeopleRoof],
	['tournament-icon', faNetworkWired],
	['impersonate', faUserSecret],
	['warning', faCircleExclamation],
	['archive', faArchive],
	['objects-column', faObjectsColumn],
	['calendar', faCalendar],
	['palette', faPalette],
	['bullseye-arrow', faBullseyeArrow],
	['percentage', faPercentage],
	['pause', faPause],
	['trial', faMoneyCheckAlt],
	['active', faDotCircle],
	['canceled', faCancel],
	['failed', faExclamationCircle],
	['export', faFileExport],
	['archive', faBoxArchive],
	['calculator', faCalculatorSimple],
	['people-arrow', faPeopleArrows],
	['news-content', faFolderGrid],
	['dollar-sign', faDollarSign],
	['stripe-logo', faCcStripe],
	['paypal-logo', faPaypal],
	['api-calls', faWebhook],
	['exdash-clubs', faClub],
	['dev-tools', faCode],
	['app-store', faAppStoreIos],
	['google-play', faGooglePlay],
	['slack', faSlack],
	['figma', faFigma],
	['github', faGithub],
	['jira', faJira],
	['bunnycdn', faKeycdn],
	['gworkspaces', faGoogleDrive],
	['fbpixel', faSquareFacebook],
	['gear', faGear],
	['affiliation-distributions', faCalculator],
	['api', faQrcode],
	['move', faShuffle]
]);

type CustomGlyph =
	| 'example'
	| 'ppa-points'
	| 'mixed'
	| 'doubles'
	| 'singles'
	| 'logo'
	| 'analytics-icon'
	| 'organizations-icon'
	| 'team-leagues-icon'
	| 'tournaments-icon'
	| 'tournaments-black-icon'
	| 'users-icon'
	| 'arrow-left'
	| 'arrow-left-orange'
	| 'injured-reserve-orange'
	| 'swap'
	| 'swap-orange'
	| 'plus'
	| 'plus-orange'
	| 'ball-orange'
	| 'ball';

const customGlyphs = new Map<CustomGlyph, any>([
	['ppa-points', PPAIcon],
	['mixed', MixedIcon],
	['doubles', DoublesIcon],
	['singles', SinglesIcon],
	['logo', Logo],
	['analytics-icon', AnalyticsIcon],
	['organizations-icon', OrganizationsIcon],
	['team-leagues-icon', TeamLeaguesIcon],
	['tournaments-icon', TournamentsIcon],
	['tournaments-black-icon', TournamentsBlackIcon],
	['users-icon', UsersIcon],
	['arrow-left', ArrowLeft],
	['arrow-left-orange', ArrowLeftOrange],
	['injured-reserve-orange', InjuredReserveOrange],
	['swap', Swap],
	['swap-orange', SwapOrange],
	['plus', Plus],
	['plus-orange', PlusOrange],
	['ball', Ball],
	['ball-orange', BallOrange]
]);

export type Glyph = FaGlyph | CustomGlyph;

interface IconProps {
	glyph: Glyph;
	id?: string;
	className?: string;
	spin?: boolean;
	size?: SizeProp;
	onClick?: () => void;
	onMouseDown?: () => void;
	height?: number;
	width?: number;
}

const IconComponent = React.forwardRef<HTMLDivElement | HTMLImageElement, IconProps>((props, ref) => {
	const { glyph, className, onMouseDown, onClick } = props;
	if (faGlyphs.has(props.glyph as FaGlyph)) {
		return (
			<FontAwesomeIcon
				icon={faGlyphs.get(glyph as FaGlyph)!}
				id={props.id}
				className={cn(className)}
				spin={props.spin as any}
				size={props.size}
				onClick={onClick}
				onMouseDown={onMouseDown}
				ref={ref as React.Ref<SVGSVGElement>}
			/>
		);
	}

	if (customGlyphs.has(props.glyph as CustomGlyph)) {
		return (
			<Image
				src={customGlyphs.get(glyph as CustomGlyph)}
				alt="svgIcon"
				className={className}
				height={props.height ?? 22}
				width={props.width ?? 22}
				ref={ref as React.Ref<HTMLImageElement>}
			/>
		);
	}

	throw new Error(`Glyph ${glyph} not supported!`);
});

IconComponent.displayName = 'Icon';

const Icon = React.memo(IconComponent);

export { Icon };
